module.exports = __webpack_public_path__ + "img/alessandro-moretto-logo.bdbf81b6.svg";